module.exports = __webpack_public_path__ + "img/img11.b3a6ea57.png";